import { z } from "zod";
import { canvasElementBaseSchema } from "./canvas-element";

export const mondayTaskPrefix = `cElement-mondayTask-`;

export const mondayTaskSchemaInternal = z.object({
  type: z.literal("mondayTask"),
  width: z.number(),
  height: z.number(),
  fill: z.string(),
  mondayItemId: z.string(),
  integrationId: z.string(),
  colorBy: z.string().nullish(),
  expanded: z.boolean().optional(),
  showAllUpdates: z.boolean().optional(),
  pinnedColumns: z.array(z.string()).optional(),
  hiddenColumns: z.array(z.string()).optional(),
  hiddenFiles: z.array(z.string()).optional(),
  expandedUpdateId: z.string().nullish(),
  fieldValues: z.record(z.any()).optional(), // For gantt compatibility
});

export const mondayTaskSchema = canvasElementBaseSchema.merge(mondayTaskSchemaInternal);
export type MondayTaskElement = z.infer<typeof mondayTaskSchema>;
